import { render, staticRenderFns } from "./FolderFormView.vue?vue&type=template&id=19d48d3d&scoped=true&"
import script from "./FolderFormView.vue?vue&type=script&lang=js&"
export * from "./FolderFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d48d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d48d3d')) {
      api.createRecord('19d48d3d', component.options)
    } else {
      api.reload('19d48d3d', component.options)
    }
    module.hot.accept("./FolderFormView.vue?vue&type=template&id=19d48d3d&scoped=true&", function () {
      api.rerender('19d48d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/FolderFormView.vue"
export default component.exports